import { render, staticRenderFns } from "./AssessorRegistration.vue?vue&type=template&id=0efc64c6&scoped=true&"
import script from "./AssessorRegistration.vue?vue&type=script&lang=js&"
export * from "./AssessorRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AssessorRegistration.vue?vue&type=style&index=0&id=0efc64c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efc64c6",
  null
  
)

export default component.exports